module.exports = __webpack_public_path__ + "static/img/small_wei.59b2ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/small_wei.png
// module id = 2WtM
// module chunks = 5